import $ from 'jquery'

export default class Util {
  static _separator = '.'

  static _getNumber (key) {
    return Number(localStorage.getItem(key) || 0)
  }

  static _getCurrentIndex (name) {

    let arr = name.split(/[\[\]]/)

    if (arr.length > 2) {
      let val = arr[1]
      return val
    }

    return ""
  }

  static getNumberFromSeparatedNumberString (value) {
    return Number(value.replace(new RegExp(`[${Util._separator}]`, 'g'), ''))
  }

  static getNumberString (value) {
    return value.replace(/[^\d]/g, '')
  }

  static getSeparatedNumberString (value) {
    return Util.getNumberString(value).replace(/\d(?=(?:\d{3})+(?!\d))/g, `$&${Util._separator}`)
  }
}
